import React from "react";
import styled from "styled-components";
// import { StaticQuery, graphql } from "gatsby";
import { RichText } from "prismic-reactjs";
import ComponentMargin from "./componentMargin";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
// import { Link } from "gatsby";

const OuterContainer = styled.footer`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 100;
`;

const InnerContainer = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1500px;
  display: flex;
  align-items: flex-end;
`;

const ContentContainer = styled.div`
  width: 100%;
  height: ${(props) => props.theme.footerHeight};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Copyright = styled.p`
  font-size: 0.75rem;
  margin: 0;
  text-align: center;
`;

const Facebook = styled(FaFacebookSquare)``;
const Linkedin = styled(FaLinkedin)``;
const SocialMedias = styled.div`
  margin-top: 1rem;
  text-align: center;
`;
const SocialMediaLink = styled.a`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block;
`;

// const query = graphql`
//   query($lang: String = "en-gb") {
//     prismic {
//       allFooter_components(lang: $lang) {
//         edges {
//           node {
//             footer_title
//           }
//         }
//       }
//     }
//   }
// `;

const Footer = ({ footerData }) => {
  if (!footerData) {
    return;
  }

  const { footer_title, linkedin, facebook } = footerData;

  return (
    <OuterContainer>
      <InnerContainer>
        <ContentContainer>
          <ComponentMargin>
            <Copyright>
              {footer_title &&
                RichText.asText(footer_title).replace(
                  "${YEAR}", // eslint-disable-line no-template-curly-in-string
                  new Date().getFullYear()
                )}
            </Copyright>
            <SocialMedias>
              {facebook && (
                <SocialMediaLink
                  href={RichText.asText(facebook)}
                  target="_blank"
                >
                  <Facebook size={"1.25rem"} />
                </SocialMediaLink>
              )}
              {linkedin && (
                <SocialMediaLink
                  href={RichText.asText(linkedin)}
                  target="_blank"
                >
                  <Linkedin size={"1.25rem"} />
                </SocialMediaLink>
              )}
            </SocialMedias>
          </ComponentMargin>
        </ContentContainer>
      </InnerContainer>
    </OuterContainer>
  );
};

export default Footer;
